import React from "react";
import {
  TryTrialBlockAppImageWrapper,
  TryTrialBlockAppsContainer,
  TryTrialBlockButtonWrapper,
  TryTrialBlockContainer,
  TryTrialBlockDetails,
  TryTrialBlockTitle,
  TryTrialBlockImageWrapper,
  TryTrialBlockWrapper
} from "./try-trial-block.styles";
import Image from "next/legacy/image";
import LiveClassMobile from "public/assets/kelas-live/live-classes-mobile.png";
import { Button } from "components/atoms/button/button";

import GetOnAppStore from "public/assets/get_colearn_on_app_store.png";
import GetOnPlayStore from "public/assets/get_colearn_on_google_play.png";

const TryTrialBlock: React.FC = () => {
  return (
    <TryTrialBlockWrapper>
      <TryTrialBlockContainer>
        <TryTrialBlockImageWrapper>
          <Image
            src={LiveClassMobile}
            alt="Live Classes on Mobile"
            layout="fill"
          />
        </TryTrialBlockImageWrapper>
        <TryTrialBlockDetails>
          <TryTrialBlockTitle>
            Jangan sampe ketinggalan jadwal Kelas Live yang bisa CoFriends coba
            gratis, ya.
          </TryTrialBlockTitle>
          <TryTrialBlockButtonWrapper>
            <Button variant="primary" isFullWidth>
              Download aplikasi
            </Button>
          </TryTrialBlockButtonWrapper>

          <TryTrialBlockAppsContainer>
            <TryTrialBlockAppImageWrapper href="https://colearn.app.link/DownloadCoLearn">
              <Image
                src={GetOnAppStore}
                alt="Download Colearn from Apple App Store"
                objectFit="contain"
                layout="fill"
              />
            </TryTrialBlockAppImageWrapper>
            <TryTrialBlockAppImageWrapper href="https://colearn.app.link/DownloadCoLearn">
              <Image
                src={GetOnPlayStore}
                alt="Download Colearn from Google Play Store"
                objectFit="contain"
                layout="fill"
              />
            </TryTrialBlockAppImageWrapper>
          </TryTrialBlockAppsContainer>
        </TryTrialBlockDetails>
      </TryTrialBlockContainer>
    </TryTrialBlockWrapper>
  );
};

export { TryTrialBlock };
